// Interview Tips Answer ****************************************************************************
// pathname: /v1/interview/tips/answer
// ************************************************************************************************
import { ApiInterviewQuestionReplyOk, ApiInterviewQuestionReplyPayload, useSwrMutationApi } from '@hooks/useSwrApi';


/**
 * @description SWR mutation: post interview tip answer
 *
 * @example
 *
 * // the endpoint expects a value
 * usage: const { trigger, data, error, ... } = useSwrInterviewTipAnswerPost(locale);
 *
 * const buttonClick = () => { void trigger({ surveyId: 1, answerId: 11 }); };
 *
 * @param locale
 */
export const useSwrInterviewTipAnswerPost = (locale = 'ro') => {
  // SWR wrapper
  const {
    data, error, trigger, isMutating, reset,
  } = useSwrMutationApi<ApiInterviewQuestionReplyOk, ApiInterviewQuestionReplyPayload>({
    url: '/v1/interview/tips/answer',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
  });

  // return data
  return {
    data,
    error,
    trigger,
    isMutating,
    reset,
  };
};
